import { gql } from "@apollo/client";

export const addChallengeAcknowledgement = gql`
  mutation addChallengeAcknowledgement($content_id: String!) {
    challengeAcknowledgement_CreateOne(content_id: $content_id) {
      _id
    }
  }
`;